import { Ds } from "@accurx/design";
import styled from "styled-components";

export const StyledLoadingButton = styled(Ds.Button)`
    width: 108px;
`;
